import { render, staticRenderFns } from "./AddDiagnostic.vue?vue&type=template&id=265d293e&scoped=true"
import script from "./AddDiagnostic.vue?vue&type=script&lang=js"
export * from "./AddDiagnostic.vue?vue&type=script&lang=js"
import style0 from "./AddDiagnostic.vue?vue&type=style&index=0&id=265d293e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265d293e",
  null
  
)

export default component.exports